import React from 'react';
import { cn } from '@/lib/utils';

export default function SectionHeading({ kicker, title, subtitle, align = 'left', className, kickerTestId }) {
  return (
    <div className={cn(align === 'center' ? 'text-center mx-auto' : '', 'max-w-3xl', className)}>
      {kicker && (
        <p data-testid={kickerTestId} className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C6A35B]">{kicker}</p>
      )}
      <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#144726] tracking-tight">{title}</h2>
      {subtitle && (
        <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">{subtitle}</p>
      )}
    </div>
  );
}
